function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesDeskFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18a3 3 0 013-3h20a3 3 0 013 3v12h-2V18a1 1 0 00-1-1H6a1 1 0 00-1 1v12H3V18z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 8v8h-2V8h2zM24.584 6A5.001 5.001 0 0015 8h10c0-.711-.148-1.388-.416-2zm-2.348 0c-.55-.614-1.348-1-2.236-1-.889 0-1.687.386-2.236 1h4.472zM7.158 6.56a1 1 0 011.282.598l1.88 5.159L8.44 13 6.56 7.842a1 1 0 01.598-1.282zM10.929 6.003a1 1 0 011.069.926l.497 5.428-1.995.143-.498-5.429a1 1 0 01.927-1.068z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21h24v2H4v-2zM14 19a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13H9v2h3v-2zm-5-2v6h7v-6H7z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesDeskFilled;